import React from "react";
import { useSelector } from "react-redux";

import { makeStyles } from "@material-ui/styles";
import Card from "@material-ui/core/Card";
import Divider from "@material-ui/core/Divider";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";

// perfect scrollbar
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";

import CardHeader from "../../../components/CardHeader";
import Table from "../../../components/Table";

import useDeepMemo from "../../../hooks/useDeepMemo";
import { getColumnsCutSummary, getRowsCutSummary } from "../cutPlanHelper";
import useSafeState from "../../../hooks/useSafeState";
import { OState } from "../../../utils/types";

const useStyles = makeStyles({
  nowrapTable: {
    whiteSpace: "pre"
  }
});

const CutSummary = props => {
  const classes = useStyles();
  const { className, order, cutOrder, planTabIdx } = props;

  const [colorIdx, setColorIdx] = useSafeState(0);

  const styleColorList = cutOrder?.styleColorList || [];
  const styleColor = styleColorList[colorIdx];

  const i18nMessages = useSelector(state => state?.i18n?.messages) || {};

  const { columns, headerRows } = useDeepMemo(() => getColumnsCutSummary(order, cutOrder), [order, cutOrder]);

  const rows = useDeepMemo(
    () => getRowsCutSummary(order, cutOrder, planTabIdx, styleColor, i18nMessages),
    [order, cutOrder, planTabIdx, styleColor, i18nMessages]
  );

  if (cutOrder?.stateValue <= OState.MAIN_CUTPLAN_GENERATED.stateValue) {
    return <div />;
  }

  return (
    <Card className={className}>
      <CardHeader title="Cut Plan Summary" />
      <Divider />
      {styleColorList.length > 1 && (
        <Tabs value={colorIdx} onChange={(e, idx) => setColorIdx(idx)} variant="scrollable" scrollButtons="auto">
          {styleColorList.map((styleColor, idx) => (
            <Tab key={idx} label={styleColor} />
          ))}
        </Tabs>
      )}
      {styleColorList.length > 1 && <Divider />}
      <PerfectScrollbar>
        <Table
          classes={{ table: classes.nowrapTable }}
          columns={columns}
          headerRows={headerRows}
          rows={rows}
          headerCellStyle={column => ({
            borderLeft: column.leftBorder ? "1px solid rgba(224, 224, 224, 1)" : undefined,
            borderRight: column.rightBorder ? "1px solid rgba(224, 224, 224, 1)" : undefined,
            backgroundColor: "#C6D0DA"
          })}
          cellStyle={({ column, record }) =>
            record.name === "Total"
              ? {
                  fontWeight: "bold",
                  borderLeft: column.leftBorder ? "1px solid rgba(224, 224, 224, 1)" : undefined,
                  borderRight: column.rightBorder ? "1px solid rgba(224, 224, 224, 1)" : undefined
                }
              : {
                  borderLeft: column.leftBorder ? "1px solid rgba(224, 224, 224, 1)" : undefined,
                  borderRight: column.rightBorder ? "1px solid rgba(224, 224, 224, 1)" : undefined
                }
          }
        />
      </PerfectScrollbar>
    </Card>
  );
};

export default CutSummary;
